import * as React from 'react';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { ProductAnalyticsEvents } from '../../../../Analytics/events/ProductAnalyticsEvents.js';
import { useEcommFacetContext } from '../../../context/EcommFacetContext.js';
import { FacetPickerColor } from '../../FacetPickers/FacetPickerColor/FacetPickerColor.js';
import { FacetPickerSize } from '../../FacetPickers/FacetPickerSize/FacetPickerSize.js';
import '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/inventory';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/utils';
import { SingleFacetTerm } from '../components/SingleFacetTerm.js';

const MultiFacetPicker = ({ children , sectionClassName , showStockIndicator =true ,  })=>{
    const { activeVariant: { stock , isExcludedFromCheckout  } , product: { productType  } ,  } = useProductData();
    const { userHasSelectedASize , setUserHasSelectedASize , setNotificationType , notificationType , handleVariantSelection , facetPickerConfig: { activeParentFacet: activeColorFacet , activeChildFacet: activeSizeFacet , colorFacets , sizeFacets , showParentFacetPicker: showColorFacets , requiresUserSizeSelection ,  } ,  } = useEcommFacetContext();
    const hasSingleSizeFacet = React.useMemo(()=>{
        return sizeFacets && (sizeFacets === null || sizeFacets === void 0 ? void 0 : sizeFacets.length) === 1;
    }, [
        sizeFacets
    ]);
    const showActiveSizeFacet = React.useMemo(()=>hasSingleSizeFacet || requiresUserSizeSelection && userHasSelectedASize
    , [
        hasSingleSizeFacet,
        requiresUserSizeSelection,
        userHasSelectedASize
    ]);
    const showSizeFacets = sizeFacets && (sizeFacets === null || sizeFacets === void 0 ? void 0 : sizeFacets.length) > 0;
    const handleColorFacetSelection = (props)=>{
        const { name , sku , facetTerm  } = props;
        ProductAnalyticsEvents.pushPdpVariantClickEvent({
            type: productType,
            name,
            id: sku,
            dimension147: facetTerm
        });
        setUserHasSelectedASize(false);
        setNotificationType('info');
        handleVariantSelection(props);
    };
    const handleSizeFacetSelection = (props)=>{
        const { name , sku , facetTerm  } = props;
        ProductAnalyticsEvents.pushPdpVariantClickEvent({
            type: productType,
            name,
            id: sku,
            frameSize: facetTerm
        });
        setUserHasSelectedASize(true);
        handleVariantSelection(props);
    };
    const stockIndicatorCheck = showStockIndicator && !showSizeFacets;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !showColorFacets && /*#__PURE__*/ React.createElement(SingleFacetTerm, {
        className: sectionClassName,
        showStockIndicator: stockIndicatorCheck
    }), showColorFacets && /*#__PURE__*/ React.createElement(FacetPickerColor, {
        className: sectionClassName,
        activeFacet: activeColorFacet,
        onPick: handleColorFacetSelection,
        items: colorFacets,
        productType: productType,
        enableStockIndicator: !isExcludedFromCheckout && (sizeFacets === null || sizeFacets === void 0 ? void 0 : sizeFacets.length) === 0 ? stock.enableStockIndicator : false
    }), children, showSizeFacets && /*#__PURE__*/ React.createElement(FacetPickerSize, {
        className: sectionClassName,
        activeFacet: showActiveSizeFacet ? activeSizeFacet : undefined,
        onPick: handleSizeFacetSelection,
        items: sizeFacets,
        productType: productType,
        notificationType: requiresUserSizeSelection ? notificationType : undefined,
        enableStockIndicator: !isExcludedFromCheckout && showActiveSizeFacet ? stock.enableStockIndicator : false
    }));
};

export { MultiFacetPicker };
//# sourceMappingURL=MultiFacetPicker.js.map
